if (!customElements.get('vn-room')) {
  customElements.define(
    'vn-room',
    class VnRoom extends HTMLElement {
      connectedCallback() {
        this.dots = [...this.querySelectorAll('.vn-room__dot')];
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.toggle(dot)));
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
        this.centerViewport();
      }

      centerViewport() {
        const viewport = this.querySelector('.vn-room__viewport');
        if (!viewport || viewport.scrollWidth <= viewport.clientWidth) return;
        requestAnimationFrame(() => {
          viewport.scrollLeft = (viewport.scrollWidth - viewport.clientWidth) / 2;
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
      }

      toggle(dot) {
        const open = dot.getAttribute('aria-expanded') !== 'true';
        this.closeAll();
        if (!open) return;
        dot.setAttribute('aria-expanded', 'true');
        document.getElementById(dot.getAttribute('aria-controls'))?.removeAttribute('hidden');
        this.activeDot = dot;
      }

      closeAll() {
        this.dots.forEach((dot) => {
          dot.setAttribute('aria-expanded', 'false');
          document.getElementById(dot.getAttribute('aria-controls'))?.setAttribute('hidden', '');
        });
        this.activeDot = null;
      }

      onDocumentClick(event) {
        if (!this.activeDot) return;
        if (event.target.closest('.vn-room__spot')) return;
        this.closeAll();
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || !this.activeDot) return;
        const dot = this.activeDot;
        this.closeAll();
        dot.focus();
      }
    }
  );
}
